import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { ReactComponent as Logo } from './../../graphics/images/leagueLogo.svg';
import AppSpinner from '../../partials/AppSpinner';
import styles from './Welcome.module.css';

const MESSAGES = [
  'איזה כיף שבאת',
  'מכינים כמה דברים',
  'מיד נעביר אותך לדף הבית',
];

const STEP_DURATION = 1000; // ms per message
const FADE_DURATION = 250;  // ms for fade transition

function Welcome() {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const newName = searchParams.get('newName');

  const [msgIndex, setMsgIndex] = React.useState(0);
  const [visible, setVisible] = React.useState(true);

  React.useEffect(() => {
    let step = 0;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        step += 1;
        if (step >= MESSAGES.length) {
          clearInterval(cycle);
          history.push('/');
          return;
        }
        setMsgIndex(step);
        setVisible(true);
      }, FADE_DURATION);
    }, STEP_DURATION);
    return () => clearInterval(cycle);
  }, [history]);

  return (
    <div className={styles.welcome}>
      <div className={styles.logo}>
        <Logo />
      </div>

      {newName && (
        <h1 className={styles.greeting}>
          ברוכים הבאים, {newName}!
        </h1>
      )}

      <div className={styles.content}>
        <AppSpinner size="large" label="" />
        <p className={`${styles.cyclingText} ${visible ? styles.fadeIn : styles.fadeOut}`}>
          {MESSAGES[msgIndex]}
        </p>
      </div>
    </div>
  );
}

export default Welcome;
